import ReactCountryFlag from 'react-country-flag';
import Localize from 'react-intl-universal';

import { get, omit } from 'lodash-es';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

import { countryISOCodeByCountry } from '@common/Countries';
import { isString, isObject } from '@common/helpers/helpers';

const StyleSelect = styled(({ ...other }) => <Select {...omit(other, 'backgroundField')} />)(
  ({ theme, backgroundField }) => ({
    background: backgroundField
      ? theme.palette.booking.backgroundField
      : theme.palette.common.white,
    '& .MuiSvgIcon-root': { color: theme.palette.primary.main }
  })
);

const menuProps = {
  PaperProps: {
    style: {
      maxHeight: 300
    }
  }
};

const SelectInput = ({
  field = {},
  options = [],
  form: { touched, errors } = {},
  accessors: { valueAccessor = 'id', textAccessor = 'value' } = {},
  required = false,
  disabled = false,
  helperText = '',
  label = '',
  isNoneOptionVisible = false,
  isSelectWithFlag = false,
  backgroundField = true,
  ...props
}) => {
  const getValue = (option, propName) => {
    if (isString(option)) {
      return option;
    }
    if (isObject(option)) {
      if (propName === textAccessor) return option[textAccessor] ?? '';
      if (propName === valueAccessor) return option[valueAccessor] ?? '';
    }
    return '';
  };

  return (
    <>
      {!!label && (
        <InputLabel
          htmlFor={field?.name}
          required={required}
          id={field?.name}
          disabled={disabled}
          error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
        >
          {label}
        </InputLabel>
      )}
      <StyleSelect
        backgroundField={backgroundField}
        size='small'
        IconComponent={KeyboardArrowDownIcon}
        labelId={field?.name}
        placeholder='Select'
        defaultValue={field?.value ?? ''}
        error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
        disabled={disabled}
        MenuProps={menuProps}
        {...field}
        {...props}
        label={label}
      >
        {isNoneOptionVisible && (
          <MenuItem value=''>
            <em>{Localize.get('Booking.none')}</em>
          </MenuItem>
        )}

        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={getValue(option, valueAccessor)}
            disabled={option?.disabled}
            sx={{ display: 'flex' }}
          >
            <Box sx={{ display: 'inline' }}>{getValue(option, textAccessor)}</Box>
            {isSelectWithFlag && (
              <ReactCountryFlag
                countryCode={countryISOCodeByCountry[get(option, 'code')?.toLowerCase()]}
                svg
                style={{
                  width: '1.2em',
                  height: '0.8em',
                  marginLeft: '0.8rem'
                }}
              />
            )}
          </MenuItem>
        ))}
      </StyleSelect>
      {get(touched, field?.name) && get(errors, field?.name) && (
        <FormHelperText error={true}>{get(errors, field?.name)}</FormHelperText>
      )}
      {helperText && (
        <FormHelperText id='component-helper-text'>{Localize.get(helperText)}</FormHelperText>
      )}
    </>
  );
};

export default SelectInput;
